module.exports = ".custom-file-label{\r\n\tpadding-right: 5rem !important;\r\n\ttext-overflow: ellipsis !important;\r\n\toverflow-x: hidden !important;\r\n}"